import { render, staticRenderFns } from "./goodsManagementAdd.vue?vue&type=template&id=0b015130&scoped=true"
import script from "./goodsManagementAdd.vue?vue&type=script&lang=js"
export * from "./goodsManagementAdd.vue?vue&type=script&lang=js"
import style0 from "./goodsManagementAdd.vue?vue&type=style&index=0&id=0b015130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b015130",
  null
  
)

export default component.exports